import React, { Fragment, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequests from "../../../utils/useRequests";
import "react-datepicker/dist/react-datepicker.css";
import { Spinner } from "react-bootstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../../utils/Snackbars";
import { checkImageValidation } from "../../../utils/Common";

const AddPoster = () => {
  const navigate = useNavigate();
  const { postRequest, getRequest, postRequestByFormData } = useRequests(); // Your custom hook for making API calls

  
  const formatLocalDate = (d) => {
  const pad = (n) => n.toString().padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    };

  const [formData, setFormData] = useState({
    poster: "",
    e_id: "",
    e_t_id: "",
    status: "Enable",
  });

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [duration, setduration] = useState("");
  const [detail, setDetail] = useState({});

  const validation1 = useFormik({
    enableReinitialize: true,
    initialValues: formData,
    validationSchema: Yup.object({
      e_t_id: Yup.string().required("Please select Ticket Type"),
      selectedDate: Yup.string().test(
        "required-if-duration-1",
        "Please select Date",
        function (value) {
          if (duration === "1") {
            return !!value;
          }
          return true;
        }
      ),
      status: Yup.string().required("Please select status"),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById("submit1");
        submit1.disabled = true;
        submit1.textContent = "Processing...";



        const formData = new FormData();
        formData.append("poster", File || formData.poster);
        formData.append("e_id", selectedEvent);
        formData.append("e_t_id", values.e_t_id);
        formData.append("status", values.status);
        const res = await postRequestByFormData("update-poster", formData);

        if (res && res.code === 200) {
          setFormData({
            poster: "",
            e_id: "",
            e_t_id: "",
          });
          fetchPoster();
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "success",
            message: res.message || "Poster updated.",
          }));
          resetAlertData();
        } else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "error",
            message: res.message || "Failed to update poster.",
          }));
          resetAlertData();
        }
        submit1.disabled = false;
        submit1.textContent = "Update";
      } catch (error) {
        console.error("Error: ", error);
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: "An error occurred while updating the poster.",
        }));
        resetAlertData();
      }
    },
  });

const fetchPoster = async () => {
    const response = await getRequest("poster");
    if (response && response.code === 200 && response.data) {

      fetchEvents(response.data);
        setFormData({
            poster: response.data.poster,
            status: response.data.status
        });

    } else {
      // No poster configured yet. Still load the events list so the admin can
      // create one, and stop the loading spinner. Pass an empty object so the
      // event-matching logic does not crash on undefined.
      console.warn("No poster found, loading events for first-time setup:", response && response.message);
      fetchEvents({});
    }
    resetAlertData();
  };

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(0);

  const fetchEvents = async (poster) => {
    const safePoster = poster || {};
    const response = await getRequest("event-list");
    if (response && response.code === 200) {
      setEvents(response.data);

      if (response.data.length !== 0) {
        if (safePoster.e_id) {
          const filteredEvent = response.data.filter(
              (event) => event.e_id == safePoster.e_id
          );

          // Only select/load if the poster's event actually exists in the list
          if (filteredEvent.length > 0) {
            setSelectedEvent(filteredEvent[0].e_id);
            fetchLoadEventDetails(safePoster.e_id, safePoster.e_t_id);
            return;
          }
        }

        // First-time setup (no saved poster / no match): default to the first
        // event and load its days/tickets so the dropdowns are populated.
        const firstEvent = response.data[0];
        setSelectedEvent(firstEvent.e_id);
        fetchEventDetails(firstEvent.e_id);
      }
    } else {
      console.error("Failed to fetch events:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "error",
        message: "Failed to fetch events",
      }));
    }
    setLoading(false);
    resetAlertData();
  };

  const [alleventsTicketTypes, setAllEventsTicketTypes] = useState([]);
  const [particularEventTicketType, setParticularEventTicketType] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedTicketType, setSelectedTicketType] = useState();

    const fetchLoadEventDetails = async (e_id, e_t_id) => {
    try {
      const response = await getRequest(`event-details/${e_id}`);
      if (response && response.code === 200) {
        const data = response.data;

        setDetail({
          start_date: data.start_datetime,
          end_date: data.end_datetime,
        });

        setAllEventsTicketTypes(response.data.eventTicketTypeData);

        const eventDate = new Date(data.start_datetime);
        const todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);

        const now = new Date();
        const [starttime, modifier] = data.start_time.split(" ");
        let [hours, minutes] = starttime.split(":").map(Number);
        if (modifier === "PM" && hours < 12) hours += 12;
        if (modifier === "AM" && hours === 12) hours = 0;
        const compareTime = new Date(now);
        compareTime.setHours(hours, minutes, 0, 0);

        let optionsData = [];
        if (data.one_day_ticket)
          optionsData.push({ value: "1", label: "1 Day" });
        if (todayDate <= eventDate) {
          if (todayDate.getDate() === eventDate.getDate()) {
            if (now < compareTime) {
              if (data.ten_day_ticket)
                optionsData.push({ value: "10", label: "10 Days" });
            }
          } else {
            if (data.ten_day_ticket)
              optionsData.push({ value: "10", label: "10 Days" });
          }
        }

        let selectedDayPass =
          optionsData.length > 0 ? optionsData[0].value : "";
        
        response.data.eventTicketTypeData.forEach(element => {
            if(element.e_t_id == e_t_id){
                selectedDayPass = element.day_pass;
            }
        });

        if (optionsData.length !== 0) {
          setOptions(optionsData);
          setduration(selectedDayPass);

          let eventTicketType = response.data.eventTicketTypeData.filter(
            (type) => String(type.day_pass) === String(selectedDayPass)
          );

          if (String(selectedDayPass) === "1") {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const startDate = new Date(data.start_datetime);
            startDate.setHours(0, 0, 0, 0);

            let dateToUse;
            if (startDate > today) {
              dateToUse = new Date(data.start_datetime);
            } else {
              dateToUse = new Date(today);
            }

            response.data.eventTicketTypeData.forEach(element => {
                if(element.e_t_id == e_t_id){
                    const newDate = new Date(element.day_date);
                    dateToUse = new Date(newDate);
                }
            });

            const pad = (n) => n.toString().padStart(2, "0");
            const formatLocalDate = (d) =>
              `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

            const dateToUseString = formatLocalDate(dateToUse);

            eventTicketType = eventTicketType.filter((type) => {
              const dayDate = new Date(type.day_date);
              const dayDateString = formatLocalDate(dayDate);
              return dayDateString === dateToUseString;
            });

            validation1.setFieldValue("selectedDate", dateToUseString);
          }

          setParticularEventTicketType(eventTicketType);

          if (eventTicketType.length > 0) {
            validation1.setFieldValue("e_t_id", e_t_id);
            setSelectedTicketType(e_t_id);
          } else {
            validation1.setFieldValue("e_t_id", "");
            setSelectedTicketType("");
          }
        } else {
          setAlertData({ variant: "error", message: "Tickets are not available" });
        }
      } else {
        setAlertData({
          variant: "error",
          message: response.message || "Failed to fetch event details",
        });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
    setLoading(false);
    resetAlertData();
  };

  const fetchEventDetails = async (e_id) => {
    try {
      const response = await getRequest(`event-details/${e_id}`);
      if (response && response.code === 200) {
        const data = response.data;

        setDetail({
          start_date: data.start_datetime,
          end_date: data.end_datetime,
        });

        setAllEventsTicketTypes(response.data.eventTicketTypeData);

        const eventDate = new Date(data.start_datetime);
        const todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);

        const now = new Date();
        const [starttime, modifier] = data.start_time.split(" ");
        let [hours, minutes] = starttime.split(":").map(Number);
        if (modifier === "PM" && hours < 12) hours += 12;
        if (modifier === "AM" && hours === 12) hours = 0;
        const compareTime = new Date(now);
        compareTime.setHours(hours, minutes, 0, 0);

        let optionsData = [];
        if (data.one_day_ticket)
          optionsData.push({ value: "1", label: "1 Day" });
        if (todayDate <= eventDate) {
          if (todayDate.getDate() === eventDate.getDate()) {
            if (now < compareTime) {
              if (data.ten_day_ticket)
                optionsData.push({ value: "10", label: "10 Days" });
            }
          } else {
            if (data.ten_day_ticket)
              optionsData.push({ value: "10", label: "10 Days" });
          }
        }

        let selectedDayPass =
          optionsData.length > 0 ? optionsData[0].value : "";

        if (optionsData.length !== 0) {
          setOptions(optionsData);
          setduration(selectedDayPass);

          let eventTicketType = response.data.eventTicketTypeData.filter(
            (type) => String(type.day_pass) === String(selectedDayPass)
          );

          if (String(selectedDayPass) === "1") {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const startDate = new Date(data.start_datetime);
            startDate.setHours(0, 0, 0, 0);

            let dateToUse;
            if (startDate > today) {
              dateToUse = new Date(data.start_datetime);
            } else {
              dateToUse = new Date(today);
            }

            const pad = (n) => n.toString().padStart(2, "0");
            const formatLocalDate = (d) =>
              `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

            const dateToUseString = formatLocalDate(dateToUse);

            eventTicketType = eventTicketType.filter((type) => {
              const dayDate = new Date(type.day_date);
              const dayDateString = formatLocalDate(dayDate);
              return dayDateString === dateToUseString;
            });

            validation1.setFieldValue("selectedDate", dateToUseString);
          }

          setParticularEventTicketType(eventTicketType);

          if (eventTicketType.length > 0) {
            validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
            setSelectedTicketType(eventTicketType[0].e_t_id);
          } else {
            validation1.setFieldValue("e_t_id", "");
            setSelectedTicketType("");
          }
        } else {
          setAlertData({ variant: "error", message: "Tickets are not available" });
        }
      } else {
        setAlertData({
          variant: "error",
          message: response.message || "Failed to fetch event details",
        });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
    setLoading(false);
    resetAlertData();
  };

  const handleChangeEvent = (e_id) => {
    setLoading(true);
    setSelectedEvent(e_id.target.value);
    fetchEventDetails(e_id.target.value);
  }

    const handleSelectChangeDuration = (duration) => {
        setduration(duration.target.value); 

        let eventTicketType = alleventsTicketTypes.filter((type) => type.day_pass == duration.target.value);

        // Auto-fill the selectedDate with start_datetime
        if (duration.target.value === "1") {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            const startDate = new Date(detail.start_date);
            startDate.setHours(0, 0, 0, 0);
            
            // If start_datetime > today, use start_datetime; otherwise use today + 1
            let dateToUse;
            if (startDate > today) {
                dateToUse = new Date(detail.start_date);
            } else {
                dateToUse = new Date(today);
            }
            
            const dateToUseString = dateToUse.toISOString().split('T')[0];
            
            eventTicketType = eventTicketType.filter((type) => {
                const dayDate = new Date(type.day_date);
                const dayDateString = dayDate.toISOString().split('T')[0];
                return dayDateString === dateToUseString;
            });
            
            validation1.setFieldValue("selectedDate", dateToUse);
        }
        
        setParticularEventTicketType(eventTicketType);

        if (eventTicketType.length > 0) {
            validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
            setSelectedTicketType(eventTicketType[0].e_t_id); 
        } else {
            validation1.setFieldValue("e_t_id", "");
            setSelectedTicketType("");
        }
    };

    const handleSelectChangeTicketType = (type) => {
        validation1.setFieldValue("e_t_id", type.target.value);
        setSelectedTicketType(type.target.value); 
    };

const handleDateChange = (e) => {
  const dateStr = e.target.value;
  const date = new Date(dateStr);

  validation1.setFieldValue("selectedDate", dateStr);

  if (duration === "1" && date) {
    const selectedDateString = formatLocalDate(date);

    let filteredEventTicketType = alleventsTicketTypes.filter((type) => {
      if (type.day_pass == "1") {
        const dayDate = new Date(type.day_date);
        const dayDateString = formatLocalDate(dayDate);
        return dayDateString === selectedDateString;
      }
      return false;
    });

    setParticularEventTicketType(filteredEventTicketType);

    if (filteredEventTicketType.length > 0) {
      validation1.setFieldValue("e_t_id", filteredEventTicketType[0].e_t_id);
      setSelectedTicketType(filteredEventTicketType[0].e_t_id);
    } else {
      validation1.setFieldValue("e_t_id", "");
      setSelectedTicketType("");
    }
  }
};

    const [File, setFile] = useState();
    const [FileName, setFileName] = useState('');
const saveFile = (e) => {
    if ((e.target.files).length > 0) {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);

        var validationRes = checkImageValidation(e.target.files[0]);
        if (!validationRes.status) {
            setFile();
            setFileName('');
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: validationRes.msg,
            }));
            resetAlertData();
            return false;
        }
    }
};

  useEffect(() => {
    fetchPoster();
  }, []);

  return (
    <Fragment>
      <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
        <h2 className="text-black font-w700 mb-0">Update Poster</h2>
      </div>


      <div className="col-lg-12">
        <div className="card">
             
          <div className="card-body">
            {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading Poster Settings...</p>
                </div>) : 
            <div className="basic-form">
              {AlertData.message !== "" ? (
                <Snackbars variant={AlertData.variant} message={AlertData.message} />
              ) : (
                ""
              )}
             <form>
  {/* Poster Upload */}
  <div className="form-group mb-3 col-md-4 col-xs-12">
    <label className="fw-bold fs-4">Poster :</label>

    <input
      type="file"
      className={`form-control ${validation1.touched.poster && validation1.errors.poster ? 'is-invalid' : ''}`}
      name="poster"
      onChange={saveFile}
    />
    
    {formData.poster && (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
        <img
          src={formData.poster}
          alt="Organizer Logo"
          style={{ width: '100px', height: 'auto', marginBottom: '10px' }}
        />
        <p style={{ color: 'black', margin: 0 }}>Only PNG, JPEG, JPG files allowed.</p>
      </div>
    )}
  </div>

  {/* Redirect To */}
  <label className="fw-bold fs-4">Redirect To :</label>

  <div className="row mb-3">
    {/* Event Dropdown */}
    <div className="form-group mb-3 col-md-4 col-xs-12">
      <label>Event</label>
      <select className="form-control" name="event" value={selectedEvent} onChange={handleChangeEvent}>
        {events.map((event) => (
          <option key={event.e_id} value={event.e_id}>
            {event.name}
          </option>
        ))}
      </select>
    </div>

    {/* Event Days Dropdown */}
    <div className="form-group mb-3 col-md-4 col-xs-12">
      <label>Event Day's</label>
      <select className="form-control" name="duration" value={duration} onChange={handleSelectChangeDuration}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>

    {/* Ticket Type Dropdown */}
    <div className="form-group mb-3 col-md-4 col-xs-12">
      <label>Ticket</label>
      <select
        className="form-control"
        name="e_t_id"
        value={validation1.values.e_t_id}
        onChange={handleSelectChangeTicketType}
      >
        {particularEventTicketType.map((ticketType) => (
          <option key={ticketType.e_t_id} value={ticketType.e_t_id}>
            {ticketType.type}
          </option>
        ))}
      </select>
    </div>

    {/* Conditional Date Picker */}
    {duration === "1" && (
      <div className="form-group mb-3 col-md-4 col-sm-12">
        <label>Date</label>
        <input
          type="date"
          name="selectedDate"
          className={`form-control ${
            validation1.touched.selectedDate && validation1.errors.selectedDate ? "is-invalid" : ""
          }`}
          value={validation1.values.selectedDate || ""}
          onChange={handleDateChange}
          min={detail.start_date ? formatLocalDate(new Date(detail.start_date)) : ""}
          max={detail.end_date ? formatLocalDate(new Date(detail.end_date)) : ""}
        />
        {validation1.errors.selectedDate && validation1.touched.selectedDate && (
          <small className="text-danger">{validation1.errors.selectedDate}</small>
        )}
      </div>
    )}

    <label className="fw-bold fs-4">Status :</label>
    {/* Enable/Disable Dropdown */}
    <div className="form-group mb-3 col-md-4 col-xs-12">
    <select
        className="form-control"
        name="status"
        value={validation1.values.status}
        onChange={validation1.handleChange}
    >
        <option value="Enable">Enable</option>
        <option value="Disable">Disable</option>
    </select>
    {validation1.errors.status && validation1.touched.status && (
        <small className="text-danger">{validation1.errors.status}</small>
    )}
    </div>

  </div>

  {/* Buttons */}
  <button
    type="submit"
    className="btn btn-primary me-2"
    id="submit1"
    onClick={(e) => {
      e.preventDefault();
      validation1.handleSubmit();
      return false;
    }}
  >
    Update
  </button>
  <Link to="/user-list" className="btn btn-light">
    Cancel
  </Link>
</form>

            </div>
             }
          </div>
          

        </div>
      </div>
    </Fragment>
  );
};

export default AddPoster;
